import { Check, MapPin } from "lucide-react";
import { CITIES, CONTACT } from "@/data/services";

/** Sektion „Einsatzgebiet" – Standort-Karte (stilisiert) + Städte-Liste für lokales SEO */
export default function ServiceArea() {
  return (
    <section className="py-16 bg-white border-b border-[#D7E5D9]" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-10 space-y-3">
          <span className="text-xs font-bold text-[#1E5631] uppercase tracking-wider">Standort &amp; Radius</span>
          <h2 className="text-3xl sm:text-4xl font-black text-[#122B18] font-display">
            Einsatzgebiet Herten + 20 km Umkreis
          </h2>
          <p className="text-[#4A634E] text-base">
            Innerhalb des 20 km Radius fallen für Sie keine gesonderten Anfahrtskosten an. Ab Kilometer 21 berechnen wir
            faire 0,70 € pro Zusatzkilometer.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <div className="w-full aspect-[16/9] rounded-2xl bg-gradient-to-br from-[#E6F3E6] via-[#D7E5D9] to-[#C3D9C7] border-2 border-[#B9E0BD] p-6 flex flex-col justify-between shadow-inner relative overflow-hidden">
              <div className="flex justify-between items-start gap-2 flex-wrap">
                <span className="bg-[#122B18] text-white text-xs font-bold px-3 py-1.5 rounded-md shadow inline-flex items-center gap-1.5">
                  <MapPin className="w-3.5 h-3.5" /> Zentrale: 45701 Herten
                </span>
                <span className="bg-[#1E5631] text-white text-xs font-bold px-3 py-1.5 rounded-md shadow">
                  20 km Radius inklusive
                </span>
              </div>
              <div className="bg-white/90 backdrop-blur-sm p-4 rounded-xl border border-[#B9E0BD] space-y-1">
                <div className="text-xs font-bold text-[#122B18]">
                  ZWILLINGSWERK Betriebssitz: {CONTACT.street}, {CONTACT.city}
                </div>
                <div className="text-xs text-[#4A634E]">
                  Täglich im Einsatz für private Gärten, Wohnanlagen und Gewerbeobjekte.
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 bg-[#F8FAF8] border border-[#D7E5D9] rounded-2xl p-6 space-y-4">
            <h3 className="text-lg font-bold text-[#122B18]">Regelmäßig bediente Städte:</h3>
            <div className="grid grid-cols-2 gap-2 text-xs sm:text-sm font-semibold text-[#1E5631]" data-testid="city-list">
              {CITIES.map((c) => (
                <div key={c} className="bg-white p-2.5 rounded border border-[#D7E5D9] flex items-center gap-1.5">
                  <Check className="w-3.5 h-3.5 shrink-0" /> {c}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
